module.exports = __webpack_public_path__ + "media/images/flags/EU-eb19272913f9028e2d9fc2d36382d980.svg";